import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@massds/mayflower-react';
import './index.scss';

const EmailSubscribe = (props) => {
  const { placeholder, buttonText } = props;
  const [email, setEmail] = useState(null);
  // Update this once we figure out where this email should go...
  const handleSubmit = ({ e, value }) => { console.log(e, value); };
  return(
    <form className="ma__input-wrapper" action="" onSubmit={(e) => handleSubmit({ e, value: email })} role="search">
      <input className="ma__input-email" type="email" id="sign-up-email" onChange={(e) => setEmail(e.target.value)} placeholder={placeholder} />
      <Button classes={['ma__button-email']} disabled={false} info="Sign up with your email to learn about budget updates" size="small" text={buttonText} theme="c-gray-dark" type="submit" usage="" />
    </form>

  );
};

EmailSubscribe.propTypes = {
  /** The text to display on the submit button * */
  buttonText: PropTypes.string,
  /** the placeholder text in the email input * */
  placeholder: PropTypes.string
};

EmailSubscribe.defaultProps = {
  buttonText: 'Notify Me!',
  placeholder: 'Enter you email, e.g. example@youremailprovider.com'
};

export default EmailSubscribe;
